import { AbstractControl, UntypedFormArray, ValidationErrors } from '@angular/forms';
import moment from 'moment-timezone';

import { ReservationOfferChannel } from '@pwp-common';

export const phoneCallsMinIntervalValidator = (control: AbstractControl): ValidationErrors | null => {
  if (!(control instanceof UntypedFormArray)) {
    return null;
  }

  const phoneCallDelaysInMs = control.controls
    .filter((offerControl) => offerControl.get('channel')?.value === ReservationOfferChannel.phoneCall)
    .map((offerControl) => moment.duration(offerControl.get('delay')?.value).asMilliseconds())
    .sort((a, b) => a - b);

  const minAllowedIntervalInMs = moment.duration(2, 'minutes').asMilliseconds();

  const isIntervalTooShort = phoneCallDelaysInMs.some((currentDelay, index) => {
    if (index === 0) return false;
    return currentDelay - phoneCallDelaysInMs[index - 1] < minAllowedIntervalInMs;
  });

  return isIntervalTooShort ? { phoneCallsIntervalTooShort: true } : null;
};
